import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Hint, Label } from '../KeyComponents';
import TextInputCopy from './TextInputCopy';
import TextInputDate from './TextInputDate';
import TextInputPhoneNumber from './TextInputPhoneNumber';
import TextInputText from './TextInputText';

function TextInput(props) {
  const {
    label, state, placeholder, name, value, size, required, className, onChange: onChangeProp, onKeyDown, type, hint, ...rest
  } = props;

  return (
    <div className={classNames('pgn__text-input-wrapper', className, { 'pgn__text-input-wrapper-filled': value !== '' }, `pgn__text-input-wrapper-${size}`, `pgn__text-input-wrapper-${state}`)}>
      {label && <Label label={label} required={required} />}
      <input
        className="pgn__text-input-field"
        placeholder={placeholder}
        value={value}
        name={name}
        type={type}
        onChange={(e) => { onChangeProp(e.target); }}
        onKeyDown={onKeyDown}
        disabled={state === 'disabled'}
        data-testid="input-text"
        readonly={state === 'readonly'}
        {...rest}
      />
      {hint && <Hint error={state === 'error'}>{hint}</Hint>}
    </div>
  );
}

TextInput.defaultProps = {
  size: 'md',
  state: 'default',
  label: '',
  required: false,
  placeholder: 'Enter text here',
  value: '',
  className: '',
  type: 'text'
};

TextInput.propTypes = {
  size: PropTypes.oneOf(['xs', 'sm', 'md']),
  state: PropTypes.oneOf(['default', 'error', 'disabled', 'readonly']),
  label: PropTypes.string,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func,
  className: PropTypes.string,
  type: PropTypes.string
};

TextInput.PhoneNumber = TextInputPhoneNumber;
TextInput.Text = TextInputText;
TextInput.Copy = TextInputCopy;
TextInput.Date = TextInputDate;

export default TextInput;
